/**
 * @file   src\components\Introduction\PendingIntroductionList.js
 * @brief  This file is responsible for pending introductions list.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useRef } from "react";
import { Button } from "react-bootstrap";
import _ from "lodash";
import IntroductionDetail from "./IntroductionDetail";
import { INTRODUCTION_NOT_A_FIT_FROM_PENDING_LIST } from "../../constants/common";

const PendingIntroductionList = (props) => {
  const {
    list,
    count,
    updateIntroPageOnScroll,
    markNotFitModelShow,
    ViewIntroductionModalShow,
  } = props;

  const scrollRef = useRef(null);

  // To handle the page scroll for pagination
  const handleScroll = () => {
    const el = scrollRef.current;
    const scrollHeight = el.scrollHeight;
    const scrollTop = el.scrollTop;
    const clientHeight = el.clientHeight;
    if (
      scrollHeight !== clientHeight &&
      scrollTop !== 0 &&
      Math.abs(scrollHeight - (scrollTop + clientHeight)) <= 1
    ) {
      const section = "pending";
      updateIntroPageOnScroll(section);
    }
  };

  return (
    <>
      {count > 0 && (
        <div className="intro-list-sec">
          <div className="title-sec">
            <h5>
              Pending <span>({count})</span>
            </h5>
          </div>
          <div
            className="property-block-scroll"
            onScroll={handleScroll}
            ref={scrollRef}
          >
            {list.map((intro) => {
              const introId = _.get(intro, "IntroductionId", "");
              return (
                <div className="property-block" key={introId}>
                  <div
                    className="property-info"
                    onClick={() => ViewIntroductionModalShow(introId)}
                  >
                    <IntroductionDetail introDetails={intro} />
                  </div>
                  <div className="property-action flex-shrink-0">
                    <Button
                      variant="light"
                      className="btn-decline"
                      onClick={() =>
                        markNotFitModelShow(
                          introId,
                          INTRODUCTION_NOT_A_FIT_FROM_PENDING_LIST
                        )
                      }
                    >
                      Mark not a fit
                    </Button>
                    <Button
                      variant="primary"
                      onClick={() => ViewIntroductionModalShow(introId)}
                    >
                      View
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};
export default PendingIntroductionList;
